import { useMediaQuery } from "@mantine/hooks";

import {
  Badge,
  Button,
  Group,
  Popover,
  Text,
  useMantineTheme,
} from "@mantine/core";

import "@mantine/charts/styles.css";
import { useState } from "react";
import moment from "moment";
import { IconChevronDown } from "@tabler/icons-react";
import { useSearchParams } from "react-router-dom";
import { DateRanges, getDateRanges } from "utils/helper";
import Moment from "react-moment";
import { DateFilterPanel } from "core/components/dateFilterPanel/DateFilterPanel";
import classes from './DateFilterControl.module.scss';
import { logger } from "utils/logger";

// weekOnly (default): a custom pick is the week from the chosen day. Pass
// weekOnly={false} to let the custom option take any start and end date.
const DateFilterControl = ({ filter, onApply, mode="range", weekOnly = true }) => {
  const theme = useMantineTheme();
  const tabletMatch = useMediaQuery(`(max-width: ${theme.breakpoints.sm})`);
  const mobileMatch = useMediaQuery(`(max-width: ${theme.breakpoints.xs})`);

  const [dateFilterOpen, setDateFilterOpen] = useState(false);

  const dateRange = filter?.dataFilter?.dateRange?.value;
  const [searchParams, setSearchParams] = useSearchParams();

  const popWidth = () => {
    var width = tabletMatch ? "100%" : 510;
    if(!tabletMatch && mode !== "range"){
      width = 290
    }
    return width;
  }
  if(!dateRange){
    return <></>
  }
  return (
    <Group
      grow={true}
      className={classes.dateFilter}
      style={{ flexGrow: mobileMatch ? 1 : 0 }}
    >
      <Popover
        shadow="sm"
        
        opened={dateFilterOpen}
        onClose={() => setDateFilterOpen(false)}
        width={popWidth()}
        position="bottom-end"
        withArrow
        closeOnClickOutside={true}
        onChange={setDateFilterOpen}
      >
        <Popover.Target>
          <div style={{ width: "100%" }}>
            <Button
              fullWidth
              variant="light"
              onClick={() => setDateFilterOpen((o) => !o)}
              px={"xs"}
            >
              <Group>
                
                <Badge color="green" variant="light">
                  {filter.dataFilter?.dateRange.item.label}
                </Badge>
                {mode !== 'range'?
                <Text
                size={"sm"}
                truncate
                className={classes.labels}
                style={{ maxWidth: mobileMatch ? 100 : "100%" }}
              >
                <Moment format="D MMM YYYY">{dateRange[0]}</Moment>
              </Text>
                :<Text
                size={"sm"}
                truncate
                className={classes.labels}
                style={{ maxWidth: mobileMatch ? 100 : "100%" }}
              >
                <Moment format="D MMM YYYY">{dateRange[0]}</Moment> -{" "}
                <Moment format="D MMM YYYY">{dateRange[1]}</Moment>
              </Text>}
                
                <IconChevronDown size={14} />
              </Group>
            </Button>
          </div>
        </Popover.Target>
        <Popover.Dropdown>
          <div style={{ display: "flex" }}>
            <DateFilterPanel
              mode={mode}
              weekOnly={weekOnly}
              showTimePicker={false}
              filter={filter.dataFilter}
              onCancel={() => setDateFilterOpen(false)}
              onApply={(vals) => {
                let urlParms = Object.fromEntries([...searchParams]);
                // const urlParms = new URLSearchParams(window.location.search);
                var startDate = vals.dateRange.value[0];
                startDate.setHours(0, 0, 0, 0);

                // if it's past the current date set it today
                const today = getDateRanges({
                  value: DateRanges.TODAY,
                });
                if (startDate > today.startDate) {
                  startDate = today.startDate;
                }

                const formattedDate = moment(startDate).format("YYYY-MM-DD");

                // End of the range (a single day when there's no end), capped
                // at today and never before the start.
                var endDate = vals.dateRange.value[1] ?? startDate;
                if (endDate > today.endDate) {
                  endDate = today.endDate;
                }
                if (endDate < startDate) {
                  endDate = startDate;
                }
                const formattedEndDate = moment(endDate).format("YYYY-MM-DD");

                // set the settings as part of the url.
                searchParams.set("weekstart", formattedDate);
                searchParams.set("weekend", formattedEndDate);
                urlParms.weekstart = formattedDate;
                urlParms.weekend = formattedEndDate;
                setSearchParams(urlParms);

                setDateFilterOpen(false);

                onApply(formattedDate, formattedEndDate);
                // setDoFetch(true);
              }}
            />
          </div>
        </Popover.Dropdown>
      </Popover>
    </Group>
  );
};

export default DateFilterControl;
